import { apiFetch } from './apiClient.js';

export interface ApiKey {
  id: string;
  tenantId: string;
  name: string;
  scopes: string[];
  status: 'active' | 'revoked';
  expiresAt?: string | null;
  lastUsedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function listApiKeys(tenantId: string): Promise<ApiKey[]> {
  const res = await apiFetch<{ items: ApiKey[] }>(`/v1/tenants/${encodeURIComponent(tenantId)}/api-keys`);
  return res.items;
}
